import { render, staticRenderFns } from "./BookingRequestList.vue?vue&type=template&id=68db2c5c&scoped=true"
import script from "./BookingRequestList.vue?vue&type=script&lang=ts"
export * from "./BookingRequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db2c5c",
  null
  
)

export default component.exports